export default "__VITE_ASSET__5ba8060f__"